const ptDirectoryBrowse: Record<
  string,
  { message: string; description: string }
> = {
  "ledgerEditor.cloneRepository": {
    message: "Clonar Repositório",
    description: "Header for clone repository dialog",
  },
  "ledgerEditor.downloadZip": {
    message: "Baixar ZIP",
    description: "Menu item to download as ZIP",
  },
  "ledgerEditor.manageSshKeys": {
    message: "Gerenciar Chaves SSH",
    description: "Menu item for SSH key management",
  },
  "ledgerEditor.thisDirectoryIsEmpty": {
    message: "Este diretório está vazio",
    description: "Message shown when directory has no contents",
  },
};

export default ptDirectoryBrowse;
